import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import {cx} from '@emotion/css'
import styled from '@emotion/styled'

import {NoStyleButton} from '@vio/atlas/src/components/designSystem/helpers/NoStyleButton'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'

const StyledButton = styled(NoStyleButton)`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s300};
  padding: ${cssTheme.layout.spacing.s300} 0;
  .--icon {
    transition: rotate 0.15s ease-in-out;
    &.--limited {
      rotate: 180deg;
    }
  }
`

const messages = defineMessages({
  showMore: {
    id: 'showMore',
    defaultMessage: 'Show more'
  },
  showLess: {
    id: 'showLess',
    defaultMessage: 'Show less'
  }
})

interface Props {
  isLimited: boolean
  onToggle: () => void
}
export const ShowMoreButton: React.FC<Props> = ({isLimited, onToggle}) => {
  const {formatMessage} = useIntl()
  return (
    <StyledButton onClick={onToggle}>
      <Text variant="bodyS">
        {formatMessage(isLimited ? messages.showMore : messages.showLess)}
      </Text>
      <Icon
        name="ChevronUp"
        colorPath="content.neutral.secondary"
        size="md"
        className={cx('--icon', isLimited && '--limited')}
      />
    </StyledButton>
  )
}
